import { environment } from '@env/environment';

import { skip } from 'rxjs/operators';

import { inject, Injectable } from '@angular/core';

import { Store } from '@ngxs/store';

import { DisplaySnackbar } from '@shared/states/dialog.actions';
import { DatabaseWrapper } from '@shared/services/database-wrapper.service';

@Injectable({
  providedIn: 'root',
})
export class AppUpdate {
  constructor() {
    const db = inject(DatabaseWrapper);
    const store = inject(Store);

    if (environment.production || environment.config === 'qa') {
      db.object('admin/core/version')
        .valueChanges()
        .pipe(skip(1))
        .subscribe(() => {
          store.dispatch(
            new DisplaySnackbar($localize`:@@zef-i18n-00016:A new version of our app is available`, {
              color: 'success',
              persistent: true,
              actionName: $localize`:@@zef-i18n-00017:Refresh`,
              actionCallback: () => window.location.reload(),
            }),
          );
        });
    }
  }
}
